module.exports = __webpack_public_path__ + "img/video.daf5ee6d.png";